import axios from "axios";
import { useEffect, useState } from "react";
import { config } from "../../data/config";
import { getCookies } from "cookies-next";
import { Button, Input, TagInput } from "rsuite";
import { useParams } from "react-router-dom";
import ImageUploader from '../tools/uploaderImage';
import ChunkedFileUpload from "../tools/chunkupload";

export default function EditStory() {
    let { Id } = useParams();

    let cookie = getCookies();
    const [data, setData] = useState<any>(null);

    const load = async () => {
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/story/' + Id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setData(res.data.message);
        } catch (error: any) {

        }
    }

    const save = async () => {
        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/story/' + Id,
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setData(res.data.message);
        } catch (error: any) {

        }
    }

    const styles = { width: '100%', display: 'block' };

    useEffect(() => {
        load();

    }, []);
    return (
        <div className="container m-auto">
            <div className="flex items-center justify-between mt-4 mb-6">
                <Button appearance="ghost" href="/dashboard/Feature/Story">
                    بازگشت
                </Button>
                <h2 className="text-lg font-semibold text-slate-800">ویرایش استوری</h2>
            </div>
            {data == null && (
                <div className="flex items-center justify-center h-40 text-slate-500 text-sm">
                    در حال بارگذاری اطلاعات استوری...
                </div>
            )}
            {data != null && (
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-2xl border border-slate-100 p-5 shadow-sm">
                            <form className="flex flex-col gap-4">
                                <div>
                                    <div className="text-right text-sm font-medium mb-1">نام</div>
                                    <Input
                                        defaultValue={data.name}
                                        onChange={(e) => setData({ ...data, name: e })}
                                    />
                                </div>
                                <div>
                                    <div className="text-right text-sm font-medium mb-1">نام کاربری</div>
                                    <Input
                                        defaultValue={data.username}
                                        onChange={(e) => setData({ ...data, username: e })}
                                    />
                                </div>
                                <div>
                                    <div className="text-right text-sm font-medium mb-1">نوشته</div>
                                    <Input
                                        as="textarea"
                                        rows={4}
                                        defaultValue={data.text}
                                        onChange={(e) => setData({ ...data, text: e })}
                                    />
                                </div>
                                <div>
                                    <div className="text-right text-sm font-medium mb-1">تگ ها</div>
                                    <TagInput
                                        defaultValue={data.tags}
                                        onChange={(e) => setData({ ...data, tags: e })}
                                        placeholder="TAGS"
                                        style={styles}
                                    />
                                </div>
                                <div className="flex justify-end mt-2">
                                    <Button appearance="primary" onClick={() => { save(); }}>
                                        ذخیره سازی
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <div className="bg-white rounded-2xl border border-slate-100 p-4 shadow-sm">
                            <div className="text-right text-sm font-medium mb-3">آواتار</div>
                            <ImageUploader key={12} id={data.id} component={'story'}></ImageUploader>
                        </div>
                        <div className="bg-white rounded-2xl border border-slate-100 p-4 shadow-sm">
                            <div className="text-right text-sm font-medium mb-3">ویدیو</div>
                            <ChunkedFileUpload key={2} id={data._id} component={'storyvideo'} ></ChunkedFileUpload>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}